import React, { useEffect, useRef, useState/* , useLayoutEffect */ } from 'react';
import * as d3 from 'd3';
import './lineage.css';
import Image from '../components/image';
import RcTooltip from 'rc-tooltip';

    // Escape special characters for valid CSS selector
        function escapeSelector(sel) {
          if (typeof CSS !== 'undefined' && CSS.escape) {
            return CSS.escape(sel);
          }
          // Fallback for older browsers
          return String(sel).replace(/([ #;?%&,.+*~:!^$[\]()=>|/])/g, '\\$1');
        }

const ICONS = {
  job: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="icon_job" transform="translate(-8449 726)">
    <rect id="Rectangle_1919" data-name="Rectangle 1919" width="24" height="24" transform="translate(8449 -726)" fill="none"/>
    <path id="icon_tree" d="M8.359,8.383h1.8v1.785H5.564a1.025,1.025,0,0,0-1.032,1.011v1.937H2.789A1.032,1.032,0,0,0,1.75,14.137v4.591A1.031,1.031,0,0,0,2.789,19.75H7.46A1.034,1.034,0,0,0,8.5,18.728V14.137a1.032,1.032,0,0,0-1.041-1.022H5.72V11.336H15.78v1.779H14.038A1.032,1.032,0,0,0,13,14.137v4.591a1.032,1.032,0,0,0,1.041,1.022h4.673a1.032,1.032,0,0,0,1.039-1.022V14.137a1.032,1.032,0,0,0-1.041-1.022H16.973V11.182a1.025,1.025,0,0,0-1.032-1.013H11.347V8.383h1.8a.974.974,0,0,0,.982-.967v-4.7a.977.977,0,0,0-.984-.969H8.359a.977.977,0,0,0-.982.967v4.7a.977.977,0,0,0,.984.969Z" transform="translate(8450.25 -724.75)" fill="currentColor" fill-rule="evenodd"/>
  </g>
</svg>`,
  task: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
  <defs>
    <clipPath id="clip-path">
      <path id="Path_8122" data-name="Path 8122" d="M0,0H24V24H0Z" transform="translate(0 0.875)" fill="#fff"/>
    </clipPath>
  </defs>
  <g id="icon_task" transform="translate(0 -0.875)" clip-path="url(#clip-path)">
    <path id="Path_8121" data-name="Path 8121" d="M17.869,7.744,13.522,3.4a1.8,1.8,0,0,0-1.269-.522H5.8a1.8,1.8,0,0,0-1.791,1.8L4,19.075a1.8,1.8,0,0,0,1.791,1.8H16.6a1.805,1.805,0,0,0,1.8-1.8V9.022A1.806,1.806,0,0,0,17.869,7.744ZM9.607,16.636,7.7,14.728a.9.9,0,1,1,1.269-1.269l1.269,1.269,3.186-3.186a.9.9,0,0,1,1.269,1.269l-3.816,3.816A.888.888,0,0,1,9.607,16.636ZM13,9.175a.9.9,0,0,1-.9-.9V4.225l4.95,4.95Z" transform="translate(1 1)" fill="currentColor"/>
  </g>
</svg>`,
  dataset: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="icon_dataset" transform="translate(-8487 726)">
    <rect id="Rectangle_1920" data-name="Rectangle 1920" width="24" height="24" transform="translate(8487 -726)" fill="none"/>
    <path id="layer-group-solid" d="M.434,5.2,8.623,8.911a.9.9,0,0,0,.748,0L17.561,5.2a.785.785,0,0,0,0-1.407L9.372.074a.9.9,0,0,0-.748,0L.434,3.789A.786.786,0,0,0,.434,5.2ZM17.561,8.3l-2.042-.926L9.836,9.95a2.026,2.026,0,0,1-1.678,0L2.476,7.374.434,8.3a.785.785,0,0,0,0,1.406l8.189,3.712a.9.9,0,0,0,.748,0l8.19-3.712a.785.785,0,0,0,0-1.406Zm0,4.493-2.034-.922L9.836,14.45a2.026,2.026,0,0,1-1.678,0l-5.69-2.579-2.035.922a.785.785,0,0,0,0,1.406l8.189,3.712a.9.9,0,0,0,.748,0l8.19-3.712A.785.785,0,0,0,17.561,12.793Z" transform="translate(8490.003 -722.993)" fill="currentColor"/>
  </g>
</svg>`,
  externalLink: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.125 9.5H11.375C11.2755 9.5 11.1802 9.53951 11.1098 9.60983C11.0395 9.68016 11 9.77554 11 9.875V12.5H3.5V5H6.875C6.97446 5 7.06984 4.96049 7.14016 4.89016C7.21049 4.81984 7.25 4.72446 7.25 4.625V3.875C7.25 3.77554 7.21049 3.68016 7.14016 3.60984C7.06984 3.53951 6.97446 3.5 6.875 3.5H3.125C2.82663 3.5 2.54048 3.61853 2.3295 3.8295C2.11853 4.04048 2 4.32663 2 4.625V12.875C2 13.1734 2.11853 13.4595 2.3295 13.6705C2.54048 13.8815 2.82663 14 3.125 14H11.375C11.6734 14 11.9595 13.8815 12.1705 13.6705C12.3815 13.4595 12.5 13.1734 12.5 12.875V9.875C12.5 9.77554 12.4605 9.68016 12.3902 9.60983C12.3198 9.53951 12.2245 9.5 12.125 9.5ZM13.4375 2H10.4375C9.93664 2 9.68633 2.60727 10.0391 2.96094L10.8765 3.79836L5.16406 9.50867C5.11162 9.56093 5.07001 9.62303 5.04162 9.6914C5.01323 9.75977 4.99862 9.83308 4.99862 9.90711C4.99862 9.98114 5.01323 10.0544 5.04162 10.1228C5.07001 10.1912 5.11162 10.2533 5.16406 10.3055L5.69539 10.8359C5.74765 10.8884 5.80974 10.93 5.87812 10.9584C5.94649 10.9868 6.0198 11.0014 6.09383 11.0014C6.16786 11.0014 6.24117 10.9868 6.30954 10.9584C6.37791 10.93 6.44001 10.8884 6.49227 10.8359L12.2019 5.12469L13.0391 5.96094C13.3906 6.3125 14 6.06641 14 5.5625V2.5625C14 2.41332 13.9407 2.27024 13.8352 2.16475C13.7298 2.05926 13.5867 2 13.4375 2Z" fill="currentColor"/>
</svg>`,
  upstream: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.33331 12.0002C6.63331 12.0002 5.98054 11.8779 5.37498 11.6335C4.76942 11.3891 4.23331 11.0557 3.76665 10.6335C3.63331 10.5113 3.5722 10.3641 3.58331 10.1918C3.59442 10.0196 3.6722 9.87239 3.81665 9.75016C3.96109 9.62794 4.12776 9.56961 4.31665 9.57516C4.50554 9.58072 4.6722 9.64461 4.81665 9.76683C5.1722 10.0557 5.55831 10.2779 5.97498 10.4335C6.39165 10.5891 6.84442 10.6668 7.33331 10.6668C8.44442 10.6668 9.38887 10.2779 10.1666 9.50016C10.9444 8.72239 11.3333 7.77794 11.3333 6.66683C11.3333 5.55572 10.9444 4.61127 10.1666 3.8335C9.38887 3.05572 8.44442 2.66683 7.33331 2.66683C6.41109 2.66683 5.5972 2.94461 4.89165 3.50016C4.18609 4.05572 3.71665 4.76127 3.48331 5.61683C3.42776 5.80572 3.32776 5.97239 3.18331 6.11683C3.03887 6.26127 2.8722 6.3335 2.68331 6.3335C2.49442 6.3335 2.34165 6.2585 2.22498 6.1085C2.10831 5.9585 2.0722 5.78905 2.11665 5.60016C2.3722 4.37794 2.98054 3.36127 3.94165 2.55016C4.90276 1.73905 6.03331 1.3335 7.33331 1.3335C8.8222 1.3335 10.0833 1.85016 11.1166 2.8835C12.15 3.91683 12.6666 5.17794 12.6666 6.66683C12.6666 7.28905 12.5666 7.87516 12.3666 8.42516C12.1666 8.97516 11.8889 9.47794 11.5333 9.9335L14.2 12.6002C14.3222 12.7224 14.3833 12.8779 14.3833 13.0668C14.3833 13.2557 14.3222 13.4113 14.2 13.5335C14.0778 13.6557 13.9222 13.7168 13.7333 13.7168C13.5444 13.7168 13.3889 13.6557 13.2666 13.5335L10.6 10.8668C10.1444 11.2224 9.64165 11.5002 9.09165 11.7002C8.54165 11.9002 7.95554 12.0002 7.33331 12.0002ZM7.11665 7.56683L7.73331 5.65016C7.76665 5.56127 7.81942 5.48627 7.89165 5.42516C7.96387 5.36405 8.04998 5.3335 8.14998 5.3335H8.54998C8.63887 5.3335 8.71665 5.35572 8.78331 5.40016C8.84998 5.44461 8.90554 5.50572 8.94998 5.5835L9.83331 7.3335C9.97776 7.3335 10.0972 7.38072 10.1916 7.47516C10.2861 7.56961 10.3333 7.68905 10.3333 7.8335C10.3333 7.97794 10.2861 8.09739 10.1916 8.19183C10.0972 8.28627 9.97776 8.3335 9.83331 8.3335H9.53331C9.44442 8.3335 9.35831 8.3085 9.27498 8.2585C9.19165 8.2085 9.12776 8.13905 9.08331 8.05016L8.43331 6.76683L7.69998 9.01683C7.66665 9.11683 7.61109 9.19461 7.53331 9.25016C7.45554 9.30572 7.36665 9.3335 7.26665 9.3335H6.96665C6.86665 9.3335 6.77498 9.30294 6.69165 9.24183C6.60831 9.18072 6.54998 9.10016 6.51665 9.00016L5.56665 5.86683L4.81665 8.00016C4.78331 8.10016 4.72498 8.18072 4.64165 8.24183C4.55831 8.30294 4.46109 8.3335 4.34998 8.3335H1.83331C1.68887 8.3335 1.56942 8.28627 1.47498 8.19183C1.38054 8.09739 1.33331 7.97794 1.33331 7.8335C1.33331 7.68905 1.38054 7.56961 1.47498 7.47516C1.56942 7.38072 1.68887 7.3335 1.83331 7.3335H3.99998L4.98331 4.4835C5.01665 4.3835 5.07498 4.30572 5.15831 4.25016C5.24165 4.19461 5.33331 4.16683 5.43331 4.16683H5.74998C5.86109 4.16683 5.95554 4.20016 6.03331 4.26683C6.11109 4.3335 6.16665 4.41683 6.19998 4.51683L7.11665 7.56683Z" fill="currentColor"/>
</svg>`,
  downstream: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.8666 5.9335L15 8.06683L14.0666 9.00016L11.9333 6.86683C11.7 7.00016 11.45 7.11127 11.1833 7.20016C10.9166 7.28905 10.6333 7.3335 10.3333 7.3335C9.49998 7.3335 8.79165 7.04183 8.20831 6.4585C7.62498 5.87516 7.33331 5.16683 7.33331 4.3335C7.33331 3.50016 7.62498 2.79183 8.20831 2.2085C8.79165 1.62516 9.49998 1.3335 10.3333 1.3335C11.1666 1.3335 11.875 1.62516 12.4583 2.2085C13.0416 2.79183 13.3333 3.50016 13.3333 4.3335C13.3333 4.6335 13.2889 4.91683 13.2 5.1835C13.1111 5.45016 13 5.70016 12.8666 5.9335ZM10.3333 6.00016C10.8 6.00016 11.1944 5.83905 11.5166 5.51683C11.8389 5.19461 12 4.80016 12 4.3335C12 3.86683 11.8389 3.47238 11.5166 3.15016C11.1944 2.82794 10.8 2.66683 10.3333 2.66683C9.86665 2.66683 9.4722 2.82794 9.14998 3.15016C8.82776 3.47238 8.66665 3.86683 8.66665 4.3335C8.66665 4.80016 8.82776 5.19461 9.14998 5.51683C9.4722 5.83905 9.86665 6.00016 10.3333 6.00016ZM11.6333 8.46683L13.3333 10.1668V13.3335C13.3333 13.7002 13.2028 14.0141 12.9416 14.2752C12.6805 14.5363 12.3666 14.6668 12 14.6668H2.66665C2.29998 14.6668 1.98609 14.5363 1.72498 14.2752C1.46387 14.0141 1.33331 13.7002 1.33331 13.3335V4.00016C1.33331 3.6335 1.46387 3.31961 1.72498 3.0585C1.98609 2.79738 2.29998 2.66683 2.66665 2.66683H6.33331C6.21109 2.94461 6.12776 3.23072 6.08331 3.52516C6.03887 3.81961 6.01665 4.11127 6.01665 4.40016C6.01665 5.61127 6.44442 6.62238 7.29998 7.4335C8.15554 8.24461 9.1722 8.65016 10.35 8.65016C10.5611 8.65016 10.7722 8.63627 10.9833 8.6085C11.1944 8.58072 11.4111 8.5335 11.6333 8.46683Z" fill="currentColor"/>
</svg>`
};

const LineageGraph = ({ data, chart_id, lineageGraphExpanded, onExternalLinkClick, focusNode,handleExternalLinkClick,error }) => {

 
  const containerRef = useRef(null);
  const svgRef = useRef(null);
  const [zoomValue, setZoomValue] = useState(10);
  const zoomBehaviorRef = useRef(null);
  const initialTransformRef = useRef(null);

  const getAllChildren = (node) => {
    let nodes = [];
    if (node.children) {
      node.children.forEach(child => {
        nodes.push(child);
        nodes = nodes.concat(getAllChildren(child));
      });
    }
    return nodes;
  };

  const getAllParents = (node) => {
    const parents = [];
    if (!node) return parents;
    let current = node.parent;
    while (current) {
      parents.push(current);
      current = current.parent;
    }
    return parents;
  };

  // D3 highlight and external handlers for React nodes (move above usage)
  function handleHighlightD3(nodeName, type, e) {
    e.preventDefault();
    const container = containerRef.current;
    if (!container) return;
    const treeData = d3.hierarchy(graphTree(data));
    const node = treeData.descendants().find(d => d.data.name === nodeName);
    if (!node) return;
    const getAllChildren = (node) => {
      let nodes = [];
      if (node.children) {
        node.children.forEach(child => {
          nodes.push(child);
          nodes = nodes.concat(getAllChildren(child));
        });
      }
      return nodes;
    };
    const getAllParents = (node) => {
      const parents = [];
      if (!node) return parents;
      let current = node.parent;
      while (current) {
        parents.push(current);
        current = current.parent;
      }
      return parents;
    };
    const relatedNodes = type === 'upstream' ? getAllParents(node) : getAllChildren(node);
    const relatedNames = relatedNodes.map(n => n.data.name);
        container.querySelectorAll('.lg-panel').forEach(panel => {
          panel.classList.remove('highlights-downstream', 'lg-panel--active', 'lg-panel--upstream', 'lg-panel--downstream');
          panel.classList.add('disable-lineagenode');
        });
        // Always highlight the direct upstream/downstream panels as well
        let directLinks, directRelated;
        if (type === 'upstream') {
          directLinks = (data.links || []).filter(l => l.destination === nodeName);
          directRelated = directLinks.map(l => l.source);
        } else {
          directLinks = (data.links || []).filter(l => l.source === nodeName);
          directRelated = directLinks.map(l => l.destination);
        }
        const highlightSet = new Set([nodeName, ...relatedNames, ...directRelated]);
        highlightSet.forEach(name => {
          const panel = container.querySelector(`#${name}`);
          if (panel) {
            panel.classList.remove('disable-lineagenode');
            // Remove previous highlighting classes
            panel.classList.remove('lg-panel--active', 'lg-panel--upstream', 'lg-panel--downstream');
            // Add appropriate highlighting classes
            if (name === nodeName) {
              panel.classList.add('lg-panel--active');
            } else if (type === 'upstream') {
              panel.classList.add('lg-panel--upstream');
            } else if (type === 'downstream') {
              panel.classList.add('lg-panel--downstream');
            }
          }
        });
        // Compute direct links for highlighting arrows as well (reuse directLinks/directRelated)
        container.querySelectorAll('path.lineage').forEach(path => {
          let isRelated = false;
          let arrowType = 'arrow';
          const src = path.getAttribute('data-source');
          const dst = path.getAttribute('data-destination');
          if (type === 'upstream') {
            // Highlight all arrows where destination is nodeName or any related node
            isRelated = ((relatedNames.includes(dst) || dst === nodeName) || (directRelated.includes(src) && dst === nodeName));
            // Also highlight arrows for direct upstreams of all related nodes
            if (relatedNames.includes(dst) && directRelated.includes(src)) {
              isRelated = true;
            }
            if (isRelated) arrowType = 'upstreamarrow';
          } else {
            // Highlight all arrows where source is nodeName or any related node
            isRelated = ((relatedNames.includes(src) || src === nodeName) || (directRelated.includes(dst) && src === nodeName));
            // Also highlight arrows for direct downstreams of all related nodes
            if (relatedNames.includes(src) && directRelated.includes(dst)) {
              isRelated = true;
            }
            if (isRelated) arrowType = 'downstreamarrow';
          }
          path.setAttribute('stroke', isRelated ? '#007BFF' : '#CED4DA');
          path.setAttribute('marker-end', `url(#${arrowType})`);
        });
  }

// Removed duplicate definition of handleExternalD3
function handleExternalD3(payload, e) {
//  alert(JSON.stringify( e))
    handleExternalLinkClick(e,error);
    return;
    
  // eslint-disable-next-line no-unreachable
  // if (e && typeof e.preventDefault === 'function') {
  //   e.preventDefault();
  // }
  
  // alert(JSON.stringify(payload))

  // if (onExternalLinkClick) {
  //   const sidebar = document.querySelector('.lineage-graph-sidebar');
  // if (sidebar) {
  //   sidebar.classList.add('show');
  // }
  //   onExternalLinkClick(payload);
  // }
}


  // React node renderer for D3 nodes
  const NodePanel = ({ nodeName, tasks, datasets, onUpstream, onDownstream, onExternal }) => {
    // Function to truncate text and create tooltip
    const truncateText = (text, maxLength = 25) => {
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength - 3) + '...';
    };

    // Add error class at render time if error at node, task, or dataset level
    let isError = data.is_error && data.is_error[nodeName];
    // Check tasks for is_error
    if (!isError && Array.isArray(tasks)) {
      isError = tasks.some(t => t.is_error === true);
    }
    // Check datasets for is_error
    if (!isError && Array.isArray(datasets)) {
      isError = datasets.some(d => d.is_error === true);
    }
    const panelClass = `lg-panel${isError ? ' lg-panel--active-error' : ''}`;
    return (
      <div className={panelClass} id={nodeName}>
      <div
        className="lg-panel-header"
        style={
          (tasks && tasks.length > 0) || (datasets && datasets.length > 0)
            ? { borderBottom: '2px solid var(--lg-panel-border-color)' }
            : { borderBottom: 'none' }
        }
      >
        <a data-type="tooltip" data-tagname={nodeName} id={`${nodeName}_jobs`} href="#!" className="jobstooltiptrigger">
          <span
            className="lg-panel-title"
            title={nodeName}
            dangerouslySetInnerHTML={{ __html: ICONS.job + ' ' + truncateText(nodeName) }}
          />
        </a>
      </div>
  {tasks && tasks.length > 0 && (
        <div className="lg-panel-body">
          <div className="lg-list">
            <div className="lg-list__heading">Tasks</div>
            {tasks.map(task => (
              <div className={`lg-list__item ${task.task_name}`} key={task.task_id}>
                <a href="#!" data-type="Task" data-tagname={nodeName} id={`${task.task_id}_task`} data-name={task.task_name} data-classname={task.task_name} className={`jobstooltiptrigger ${task.task_name}`}
                  onClick={e => {
                    e.preventDefault();
                    if (onExternal) onExternal({ name: nodeName, type: 'task', selected: task }, e);
                  }}
                >
                  <div className="lg-list__label" dangerouslySetInnerHTML={{ __html: ICONS.task + '<span> ' + task.task_name+ '</span> ' }} />
                  <div className="lg-list__actions">
                    <div className="lg-list__actions-left">
                      <RcTooltip placement="top" overlay={<span>Click to view upstream</span>}><span className="upstream" data-name={nodeName} onClick={onUpstream} dangerouslySetInnerHTML={{ __html: ICONS.upstream }} /></RcTooltip>
                      <RcTooltip placement="top" overlay={<span>Click to view downstream</span>}><span className="downstream" data-name={nodeName} onClick={onDownstream} dangerouslySetInnerHTML={{ __html: ICONS.downstream }} /></RcTooltip>
                    </div>
                    <div className="lg-list__actions-right">
                      <RcTooltip placement="top" overlay={<span>Click to open details</span>}><span className="rightpaneldetail" data-type={"Task"} data-name={task.task_name} dangerouslySetInnerHTML={{ __html: ICONS.externalLink }} /></RcTooltip>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
          {datasets && datasets.length > 0 && (
            <div className="lg-list">
              <div className="lg-list__heading">Datasets</div>
              {/* {datasets.map(dataset => dataset && (
                <a href="#" data-type="dataset" data-tagname={nodeName} id={`${dataset.lineage_dataset_id}_dataset`} data-classname={dataset.pipeline_data_set_name} className={`jobstooltiptrigger ${dataset.pipeline_data_set_name}`} key={dataset.lineage_dataset_id}>
                  <div className={`lg-list__item ${dataset.pipeline_data_set_name}`}>
                    <div className="lg-list__label" dangerouslySetInnerHTML={{ __html: ICONS.dataset + ' ' + dataset.pipeline_data_set_name }} />
                  </div>
                </a>
              ))} */}

                {datasets.map(dataset => (
              <div className={`lg-list__item ${dataset.pipeline_data_set_name}`} key={dataset.lineage_dataset_id}>
                <a href="#!" data-type="Dataset" data-tagname={nodeName} id={`${dataset.lineage_dataset_id}_dataset`} data-classname={dataset.pipeline_data_set_name} className={`jobstooltiptrigger ${dataset.pipeline_data_set_name}`}
                  onClick={e => {
                    e.preventDefault();
                    if (onExternal) onExternal({ name: nodeName, type: 'dataset', selected: dataset }, e);
                  }}
                >
                  <div className="lg-list__label" dangerouslySetInnerHTML={{ __html: ICONS.dataset + '<span> ' + dataset.pipeline_data_set_name + '</span> ' }} />
                  <div className="lg-list__actions">
                    <div className="lg-list__actions-left">
                      <RcTooltip placement="top" overlay={<span>Click to view upstream</span>}><span className="upstream" data-name={nodeName} onClick={onUpstream} dangerouslySetInnerHTML={{ __html: ICONS.upstream }} /></RcTooltip>
                      <RcTooltip placement="top" overlay={<span>Click to view downstream</span>}><span className="downstream" data-name={nodeName} onClick={onDownstream} dangerouslySetInnerHTML={{ __html: ICONS.downstream }} /></RcTooltip>
                    </div>
                    <div className="lg-list__actions-right">
                      <RcTooltip placement="top" overlay={<span>Click to open details</span>}><span className="rightpaneldetail" data-type={"Dataset"} data-name={dataset.pipeline_data_set_name} dangerouslySetInnerHTML={{ __html: ICONS.externalLink }} /></RcTooltip>
                    </div>
                  </div>
                </a>
              </div>
            ))}

            </div>
          )}
        </div>
      )}
    </div>
    );
  };

  // Helper to render React nodes into D3 foreignObject
  function renderReactNodeToForeignObject(node, tasks, datasets, foreignObject) {
    import('react-dom').then(ReactDOM => {
      ReactDOM.render(
        <NodePanel
          nodeName={node}
          tasks={tasks}
          datasets={datasets}
          onUpstream={e => handleHighlightD3(node, 'upstream', e)}
          onDownstream={e => handleHighlightD3(node, 'downstream', e)}
          onExternal={e => handleExternalD3(node, e)}
        />, foreignObject);
    });
  }

  const graphTree = (graph) => {
    const nodesMap = new Map();
    // Collect all node names from tasks, links, and datasets
    const allNodeNames = new Set([
      ...Object.keys(graph.tasks || {}),
      ...(graph.links || []).flatMap(link => [link.source, link.destination]),
      ...Object.keys(graph.datasets || {})
    ]);

    allNodeNames.forEach(key => {
      const taskData = graph.tasks?.[key] || [];
      const datasetData = graph.datasets?.[key] || [];
      // Calculate height with a minimum value of 120
      const taskcnt = taskData.length;
      const datasetcnt = datasetData ? datasetData.length : 0;
      const heightCalculation = Math.max(datasetcnt * 40 + taskcnt * 45 + 125, 50);

      // Calculate width based on content
      let maxWidth = Math.max(200, (key.length * 8) + 60); // base width for node name
      taskData.forEach(task => {
        const taskWidth = (task.task_name.length * 8) + 80;
        maxWidth = Math.max(maxWidth, taskWidth);
      });
      if (datasetData) {
        datasetData.forEach(dataset => {
          const datasetWidth = (dataset.pipeline_data_set_name.length * 8) + 80;
          maxWidth = Math.max(maxWidth, datasetWidth);
        });
      }
      const widthCalculation = Math.min(maxWidth, 400); // cap at 400px

      const newNode = {
        name: key,
        is_error: graph.is_error === undefined ? false : graph.is_error,
        contentheight: heightCalculation,
        contentwidth: widthCalculation,
        contenttaskcnt: taskcnt,
        contentdatasetcnt: datasetcnt,
        children: []
      };
      nodesMap.set(key, newNode);
    });

    // If no links, but there are tasks or datasets, return a single root node
    if (!Array.isArray(graph.links) || graph.links.length === 0) {
      // Try to use pipeline_name as root if it exists in tasks or datasets
      const rootName = graph.pipeline_name && nodesMap.has(graph.pipeline_name)
        ? graph.pipeline_name
        : (nodesMap.size > 0 ? Array.from(nodesMap.keys())[0] : null);
      return rootName ? nodesMap.get(rootName) : null;
    }

    const destinationSet = new Set(graph.links.map(link => link.destination));
    const allSources = new Set(graph.links.map(link => link.source));
    // Find all root node names (sources that are not destinations)
    const rootNodeNames = Array.from(allSources).filter(src => !destinationSet.has(src));

    // Build the tree by linking nodes, ensuring each node is only added once
    const visited = new Set();
    graph.links.forEach(link => {
      const sourceNode = nodesMap.get(link.source);
      const targetNode = nodesMap.get(link.destination);
      if (sourceNode && targetNode && !visited.has(targetNode.name)) {
        sourceNode.children.push(targetNode);
        visited.add(targetNode.name);
      }
    });

    // Find all nodes that are not children of any other node (disconnected nodes)
    const allNodeNamesArr = Array.from(nodesMap.keys());
    const childNames = new Set();
    nodesMap.forEach(node => {
      node.children.forEach(child => childNames.add(child.name));
    });
    const disconnectedNodes = allNodeNamesArr.filter(name => !childNames.has(name) && !rootNodeNames.includes(name));

    // If multiple roots or disconnected nodes, create a dummy root
    if (rootNodeNames.length + disconnectedNodes.length > 1) {
      // Only include nodes that are not children of any other node (true roots and disconnected)
      const childNames = new Set();
      nodesMap.forEach(node => {
        node.children.forEach(child => childNames.add(child.name));
      });
      const uniqueNames = Array.from(new Set([...rootNodeNames, ...disconnectedNodes]));
      const filteredNames = uniqueNames.filter(name => !childNames.has(name));
      const children = filteredNames.map(name => nodesMap.get(name)).filter(Boolean);
      const dummyRoot = {
        name: 'ROOT',
        is_error: false,
        contentheight: 80,
        contentwidth: 200,
        contenttaskcnt: 0,
        contentdatasetcnt: 0,
        children
      };
      return dummyRoot;
    } else if (rootNodeNames.length === 1) {
      return nodesMap.get(rootNodeNames[0]);
    } else if (allNodeNamesArr.length === 1) {
      return nodesMap.get(allNodeNamesArr[0]);
    } else {
      return null;
    }
  };

  const drawGraph = () => {
    if (!svgRef.current || !containerRef.current || !data.tasks) return;

    // Extra horizontal spacing for nodes and arrows
    const extraX = 15; // Reduced from 30 to 15 for tighter spacing

    d3.select(svgRef.current).selectAll('*').remove();
    let dataFromGraph = graphTree(data);
    if (!dataFromGraph) return;

    // If the root is the dummy 'ROOT', flatten its children as top-level roots
    let roots = [];
    if (dataFromGraph.name === 'ROOT' && Array.isArray(dataFromGraph.children)) {
      roots = dataFromGraph.children;
    } else {
      roots = [dataFromGraph];
    }

    // Create a virtual parent node to layout all roots horizontally (forest layout)
    const virtualRoot = { name: '__VIRTUAL_ROOT__', children: roots };
    const root = d3.hierarchy(virtualRoot);
    // Only render children, not the virtual root itself
    // The rest of the code will work as before, but skip rendering for the virtual root
    
    // Calculate dynamic width for each node based on content
    function getDynamicNodeWidth(node) {
      const nodeName = node.data.name;
      const tasks = data.tasks[nodeName] || [];
      const datasets = data.datasets[nodeName] || [];
      // Hide the dummy root node and virtual root
      if (nodeName === 'ROOT' || nodeName === '__VIRTUAL_ROOT__') return 0;
      // Base width for node name (icon + name + padding) - more conservative for root nodes
      const isRootNode = node.depth === 1; // Now, real roots are at depth 1
      const baseWidth = isRootNode 
        ? Math.max(180, Math.min((nodeName.length * 6) + 50, 280)) // More conservative for root
        : Math.max(200, (nodeName.length * 8) + 60); // 8px per character + icon space
      let maxWidth = baseWidth;
      // Check task names
      tasks.forEach(task => {
        const taskWidth = (task.task_name.length * 8) + 80; // padding for icon and actions
        maxWidth = Math.max(maxWidth, taskWidth);
      });
      // Check dataset names
      datasets.forEach(dataset => {
        const datasetWidth = (dataset.pipeline_data_set_name.length * 8) + 80;
        maxWidth = Math.max(maxWidth, datasetWidth);
      });
      return Math.min(maxWidth, isRootNode ? 320 : 400); // Lower cap for root nodes
    }
    
    // Calculate and store individual dynamic width for each node
    root.each(node => {
      const nodeWidth = getDynamicNodeWidth(node);
      // Store the calculated width in the node data
      if (node.data) {
        node.data.calculatedWidth = nodeWidth;
      }
    });
    
    const containerWidth = containerRef.current.clientWidth;
    const containerHeight = containerRef.current.clientHeight;
    const padding = 50;

    // Dynamically calculate vertical spacing based on content
    function getDynamicNodeSize(root) {
      // Use appropriate spacing based on content - smaller gap for empty nodes
      const hasContentNodes = root.descendants().some(node => 
        node.data && (node.data.contenttaskcnt > 0 || node.data.contentdatasetcnt > 0)
      );
      
      // Use smaller spacing (80px) for graphs with only empty nodes, larger spacing (120px) for content-rich graphs
      return hasContentNodes ? 120 : 80;
    }
    
    // Set all node heights based on the maximum height of top-level (root) nodes
    let maxTopNodeHeight = 80; // minimum height
    root.each(node => {
      if (node.depth === 1 && node.data && node.data.contentheight && node.data.name !== 'ROOT' && node.data.name !== '__VIRTUAL_ROOT__') {
        maxTopNodeHeight = Math.max(maxTopNodeHeight, node.data.contentheight);
      }
    });
    
    // Apply height logic: nodes with no content get 52px, others keep their calculated height
    root.each(node => {
      if (node.data && node.data.name !== 'ROOT' && node.data.name !== '__VIRTUAL_ROOT__') {
        const hasContent = node.data.contenttaskcnt > 0 || node.data.contentdatasetcnt > 0;
        if (!hasContent) {
          // Nodes with no tasks and no datasets get exactly 52px
          node.data.contentheight = 70;
        } else {
          // Nodes with content keep their calculated height, but ensure minimum consistency
          node.data.contentheight = Math.max(node.data.contentheight, maxTopNodeHeight);
        }
      }
    });
    
    // Apply individual calculated widths to node data
    root.each(node => {
      if (node.data && node.data.name !== 'ROOT' && node.data.name !== '__VIRTUAL_ROOT__') {
        node.data.contentwidth = node.data.calculatedWidth || 200;
      }
    });
    
    const dynamicNodeHeight = getDynamicNodeSize(root);
    // Use a base separation that accounts for variable widths and heights
    const treeLayout = d3.tree()
      .nodeSize([dynamicNodeHeight, 350]) // Base horizontal spacing (increased by 100px)
      .separation((a, b) => {
        // Dynamic separation based on node widths and heights
        const aWidth = a.data?.calculatedWidth || 200;
        const bWidth = b.data?.calculatedWidth || 200;
        const aHeight = a.data?.contentheight || 80;
        const bHeight = b.data?.contentheight || 80;
        // Calculate width-based separation
        const avgWidth = (aWidth + bWidth) / 2;
        const widthSeparation = Math.max(1.5, avgWidth / 150);
        // Calculate height-based vertical separation to prevent overlaps
        const avgHeight = (aHeight + bHeight) / 2;
        const heightSeparation = Math.max(1.2, avgHeight / 100); // Scale based on content height
        // Use the larger of width or height separation, but ensure minimum spacing
        return Math.max(widthSeparation, heightSeparation);
      });
    let treeData = treeLayout(root);

    const svg = d3.select(svgRef.current)
      .attr('width', containerWidth)
      .attr('height', containerHeight);

    const g = svg.append('g'); // All graph elements go inside this group
    const nodesGroup = g.append('g').attr('class', 'nodes-group');
    const edgesGroup = g.append('g').attr('class', 'edges-group');

    const zoom = d3.zoom()
      .scaleExtent([0.1, 3])
      .on('start', function() {
        // Add visual feedback when starting to drag
        d3.select(this).style('cursor', 'grabbing');
      })
      .on('zoom', () => {
        g.attr('transform', d3.event.transform);
        setZoomValue(Math.round(d3.event.transform.k * 10));
      })
      .on('end', function() {
        // Reset cursor when drag ends
        d3.select(this).style('cursor', 'grab');
      })
      .filter(function() {
        // d3 v5: use d3.event, not event param
        return !(d3.event && d3.event.type === 'dblclick');
      });

    svg.call(zoom);
    zoomBehaviorRef.current = zoom;

    // Add click handler to reset upstream/downstream selections when clicking on empty SVG space
    svg.on('click', function() {
      // Only reset if clicking on the SVG itself (not on nodes or other elements)
      if (d3.event.target === svg.node()) {
        // Reset all upstream/downstream highlights and disabled panels
        d3.selectAll('.lg-panel').classed('highlights-downstream disable-lineagenode lg-panel--active lg-panel--upstream lg-panel--downstream', false);
        // Reset arrow highlights
        d3.selectAll('.lineage').attr('stroke', '#CED4DA').attr('marker-end', 'url(#arrow)');
      }
    });

    const defs = g.append('defs');

    // Marker Definitions
    const markers = [
      { id: 'arrow', color: '#CED4DA' },
      { id: 'upstreamarrow', color: '#007BFF' },
      { id: 'downstreamarrow', color: '#F64E60' }
    ];

    markers.forEach(m => {
      defs.append('marker')
        .attr('id', m.id)
        .attr('viewBox', '0 -5 10 10')
        .attr('refX', 8).attr('refY', 0)  // Position arrow at the end of the path
        .attr('markerWidth', 6).attr('markerHeight', 6)
        .attr('orient', 'auto')  // Auto-orient to follow curve direction
        .append('path').attr('d', 'M0,-5L10,0L0,5').style('fill', m.color);
    });

    // Only render nodes that are not the dummy root or virtual root
    const nodes = nodesGroup.selectAll('.node')
      .data(treeData.descendants().filter(d => d.data.name !== 'ROOT' && d.data.name !== '__VIRTUAL_ROOT__'))
      .enter().append('g')
      .attr('class', d => `node ${d.data.name}`)
      .attr('transform', d => `translate(${d.y + padding + extraX}, ${d.x + padding})`);

    nodes.append('foreignObject')
      .attr('class', 'nodegroup')
      .attr('width', d => d.data.contentwidth)
      .attr('height', d => d.data.contentheight)
      .each(function(d) {
        renderReactNodeToForeignObject(
          d.data.name,
          data.tasks[d.data.name] || [],
          data.datasets[d.data.name] || [],
          this
        );
      });

    // Set error state panels by default after rendering
    if (data.is_error) {
      Object.keys(data.is_error).forEach(name => {
        if (data.is_error[name]) {
          const panel = containerRef.current.querySelector(`#node-${name}`);
          if (panel) {
            panel.classList.add('lg-panel--active-error');
            panel.classList.remove('highlights-downstream', 'lg-panel--active', 'lg-panel--upstream', 'lg-panel--downstream');
          }
        }
      });
    }
  // eslint-disable-next-line no-unused-vars
  function handleExternalD3(nodeName, e) {
    return;
    // eslint-disable-next-line no-unreachable
    // e.preventDefault();
    // if (onExternalLinkClick) onExternalLinkClick(nodeName);
  }

    data.links.forEach(link => {
      const sourceNode = treeData.descendants().find(d => d.data.name === link.source);
      const destNode = treeData.descendants().find(d => d.data.name === link.destination);

      if (sourceNode && destNode) {
        // Adjust x positions for extraX spacing
        const getNodeHeight = node => node.data.contentheight;
        const x1 = sourceNode.y + padding + extraX + sourceNode.data.contentwidth;
        const y1 = sourceNode.x + padding + getNodeHeight(sourceNode) / 2; // Center of source node
        const x2 = destNode.y + padding + extraX;
        const y2 = destNode.x + padding + getNodeHeight(destNode) / 2; // Center of destination node
        
        // Create ultra-smooth curved custom line with enhanced dynamic logic
        const dx = x2 - x1;
        const dy = y2 - y1;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        
        // Enhanced curve intensity for smoother, more curved lines
        const baseIntensity = Math.min(0.8, Math.max(0.3, distance / 250)); // Higher base intensity
        const angleFactor = Math.abs(Math.sin(angle)) * 0.4; // More angle influence
        const verticalFactor = Math.abs(dy) / Math.max(distance, 100) * 0.3; // Vertical distance influence
        const curveIntensity = Math.min(1.0, baseIntensity + angleFactor + verticalFactor);
        
        // Enhanced control point positioning for ultra-smooth curves
        let cp1x, cp1y, cp2x, cp2y;
        
        if (Math.abs(dy) < 30) { // Very horizontal - elegant S-curve
          const curveHeight = curveIntensity * 60; // Increased curve height
          cp1x = x1 + distance * 0.35; // Slightly more forward
          cp1y = y1 + (dy > 0 ? curveHeight : -curveHeight);
          cp2x = x2 - distance * 0.35;
          cp2y = y2 + (dy > 0 ? -curveHeight : curveHeight);
        } else { // Vertical or diagonal - flowing organic curve
          const curveDirection = dy > 0 ? 1 : -1;
          const verticalOffset = curveIntensity * Math.abs(dy) * 0.4; // More vertical influence
          cp1x = x1 + distance * 0.3; // Better spacing
          cp1y = y1 + curveDirection * verticalOffset;
          cp2x = x2 - distance * 0.3;
          cp2y = y2 - curveDirection * verticalOffset;
        }
        
        // Optional: Add intermediate curve points for even smoother flow
        const pathData = `M ${x1} ${y1} C ${cp1x} ${cp1y} ${cp2x} ${cp2y} ${x2} ${y2}`;

        edgesGroup.append('path')
          .attr('d', pathData)
          .attr('data-source', link.source)
          .attr('data-destination', link.destination)
          .attr('class', 'lineage')
          .attr('stroke', '#CED4DA').attr('stroke-width', 2).attr('fill', 'none')
          .attr('marker-end', 'url(#arrow)');
      }
    });

    const showPanelAlert = (nodeName, treeData) => {
      const node = treeData.descendants().find(d => d.data.name === nodeName);
      if (!node) return;

      // Collect upstream node names
      const upstreamNodes = [];
      const collectUpstreamNodes = (name, visited = new Set()) => {
        if (visited.has(name)) return;
        visited.add(name);
        
        const directUpstream = (data.links || []).filter(link => link.destination === name);
        directUpstream.forEach(link => {
          if (!upstreamNodes.includes(link.source)) {
            upstreamNodes.push(link.source);
          }
          collectUpstreamNodes(link.source, visited);
        });
      };
      collectUpstreamNodes(nodeName);
      const upstreamCount = upstreamNodes.length;

      // Collect downstream node names
      const downstreamNodes = [];
      const collectDownstreamNodes = (name, visited = new Set()) => {
        if (visited.has(name)) return;
        visited.add(name);
        
        const directDownstream = (data.links || []).filter(link => link.source === name);
        directDownstream.forEach(link => {
          if (!downstreamNodes.includes(link.destination)) {
            downstreamNodes.push(link.destination);
          }
          collectDownstreamNodes(link.destination, visited);
        });
      };
      collectDownstreamNodes(nodeName);
      const downstreamCount = downstreamNodes.length;

      // Build detailed alert message
      // let alertMessage = `Panel: ${nodeName}\n`;
      // alertMessage += `Upstream count: ${upstreamCount}\n`;
      // alertMessage += `Downstream count: ${downstreamCount}\n`;

      // Add upstream node names if any
      // if (upstreamCount > 0) {
      //   alertMessage += `\nUpstream nodes:\n`;
      //   upstreamNodes.forEach(node => {
      //     alertMessage += `- ${node}\n`;
      //   });
      // }

      // Add downstream node names if any
      // if (downstreamCount > 0) {
      //   alertMessage += `\nDownstream nodes:\n`;
      //   downstreamNodes.forEach(node => {
      //     alertMessage += `- ${node}\n`;
      //   });
      // }

      // Show alert with detailed counts and node names
      //alert(alertMessage);

const el = document.getElementById('pipeline_downstream_jobs');
    if (!el) return;
    el.textContent = downstreamCount ?? 0; // fallback to 0

    const eljobs = document.getElementById('pipeline_upstream_jobs');
    if (!eljobs) return;
    eljobs.textContent = upstreamCount ?? 0; // fallback to 0

    };

    setTimeout(() => {
      // Event Listeners
      const container = containerRef.current;
      if (!container) return;

      container.querySelectorAll('.rightpaneldetail').forEach(el => {
        el.addEventListener('click', (e) => {
          // Only open details panel if not clicking upstream or downstream icons
          // (rightpaneldetail is only on the details icon, so this is sufficient)
          e.preventDefault();

           const sidebar = document.querySelector('.lineage-graph-sidebar');
  if (sidebar) {
    sidebar.classList.add('show');
  }

          const nodeName = el.getAttribute('data-name');
          const nodeType = el.getAttribute('data-type');
            const element = document.getElementById("task_dataset_name");

            if (
              element &&
              typeof nodeType === "string" && nodeType.trim() !== "" &&
              typeof nodeName === "string" && nodeName.trim() !== ""
            ) {
              element.innerHTML = `${nodeType} : ${nodeName}`;
            }
          let type = 'task';
          let selected = null;
          const parent = el.closest('[data-type]');
          if (parent) type = parent.getAttribute('data-type');
          // Find the full object for task or dataset
          if (type === 'task' && data && data.tasks) {
            for (const key in data.tasks) {
              const found = (data.tasks[key] || []).find(t => t.task_name === nodeName);
              if (found) { selected = found; break; }
            }
          } else if (type === 'dataset' && data && data.datasets) {
            for (const key in data.datasets) {
              const found = (data.datasets[key] || []).find(d => d.pipeline_data_set_name === nodeName);
              if (found) { selected = found; break; }
            }
          }
          if (nodeName && onExternalLinkClick) onExternalLinkClick({ name: nodeName, type, selected });
        });
      });

      const handleHighlight = (e, type) => {
        e.preventDefault();
        const nodeElement = e.currentTarget.closest('.node');
        if (!nodeElement) return;

        const nodeName = nodeElement.classList[1];
        const node = treeData.descendants().find(d => d.data.name === nodeName);
        if (!node) return;

        const relatedNodes = type === 'upstream' ? getAllParents(node) : getAllChildren(node);
        const relatedNames = relatedNodes.map(n => n.data.name);

        showPanelAlert(nodeName, treeData);

        container.querySelectorAll('.lg-panel').forEach(panel => {
          panel.classList.remove('highlights-downstream', 'lg-panel--active');
          panel.classList.add('disable-lineagenode');
        });

        // Always highlight the direct upstream/downstream panels as well
        let directLinks, directRelated;
        if (type === 'upstream') {
          directLinks = (data.links || []).filter(l => l.destination === nodeName);
          directRelated = directLinks.map(l => l.source);
        } else {
          directLinks = (data.links || []).filter(l => l.source === nodeName);
          directRelated = directLinks.map(l => l.destination);
        }

        [nodeName, ...relatedNames].forEach(name => {
          const panel = container.querySelector(`#${name}`);
          if (panel) {
            panel.classList.remove('disable-lineagenode');
            // panel.classList.add('highlights-downstream');
            if (name === nodeName) {
              panel.classList.add('lg-panel--active');
            } else if (type === 'upstream') {
              panel.classList.add('lg-panel--upstream');
            } else if (type === 'downstream') {
              panel.classList.add('lg-panel--downstream');
            }
          }
        });

        // Also highlight direct related panels
        directRelated.forEach(name => {
          const panel = container.querySelector(`#${name}`);
          if (panel) {
            panel.classList.remove('disable-lineagenode');
            // panel.classList.add('highlights-downstream');
            if (type === 'upstream') {
              panel.classList.add('lg-panel--upstream');
            } else if (type === 'downstream') {
              panel.classList.add('lg-panel--downstream');
            }
          }
        });

        container.querySelectorAll('path.lineage').forEach(path => {
          let isRelated = false;
          const src = path.getAttribute('data-source');
          const dst = path.getAttribute('data-destination');
          if (type === 'upstream') {
            // Highlight all arrows where destination is nodeName or any related node
            isRelated = ((relatedNames.includes(dst) || dst === nodeName) || (directRelated.includes(src) && dst === nodeName));
            // Also highlight arrows for direct upstreams of all related nodes
            if (relatedNames.includes(dst) && directRelated.includes(src)) {
              isRelated = true;
            }
          } else {
            // Highlight all arrows where source is nodeName or any related node
            isRelated = ((relatedNames.includes(src) || src === nodeName) || (directRelated.includes(dst) && src === nodeName));
            // Also highlight arrows for direct downstreams of all related nodes
            if (relatedNames.includes(src) && directRelated.includes(dst)) {
              isRelated = true;
            }
          }
          path.setAttribute('stroke', isRelated ? '#007BFF' : '#CED4DA');
          path.setAttribute('marker-end', isRelated ? 'url(#upstreamarrow)' : 'url(#arrow)');
        });
      };

      container.querySelectorAll('.upstream').forEach(el => el.addEventListener('click', (e) => handleHighlight(e, 'upstream')));
      container.querySelectorAll('.downstream').forEach(el => el.addEventListener('click', (e) => handleHighlight(e, 'downstream')));

      // Prevent details panel from opening on upstream/downstream icon click
      container.querySelectorAll('.upstream, .downstream').forEach(el => {
        el.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
    }, 100);

    // Initial Zoom/Center
    setTimeout(() => {
      if (svgRef.current && containerRef.current) {
        const descendants = treeData.descendants();
        if (descendants.length === 0) return;

        // Find the focused node
        const focusPanelName = focusNode || data.pipeline_name;
        const focusNodeObj = descendants.find(d => d.data.name === focusPanelName);

        let scale = 1;
        let translateX = 0;
        let translateY = 0;

        if (focusNodeObj) {
          // Center on the focused node
          const nodeX = focusNodeObj.y + padding + extraX + focusNodeObj.data.contentwidth / 2;
          const nodeY = focusNodeObj.x + padding + focusNodeObj.data.contentheight / 2;
          scale = Math.min(
            (containerWidth - padding * 2) / focusNodeObj.data.contentwidth,
            (containerHeight - padding * 2) / focusNodeObj.data.contentheight,
            1
          );
          translateX = containerWidth / 2 - nodeX * scale;
          translateY = containerHeight / 2 - nodeY * scale;
        } else {
          // Fallback: center the bounding box of all nodes
          let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
          descendants.forEach(d => {
            const x = d.y + padding;
            const y = d.x + padding;
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x + d.data.contentwidth);
            maxY = Math.max(maxY, y + d.data.contentheight);
          });
          scale = Math.min((containerWidth - padding * 2) / (maxX - minX), (containerHeight - padding * 2) / (maxY - minY), 1);
          translateX = containerWidth / 2 - ((minX + maxX) / 2) * scale;
          translateY = containerHeight / 2 - ((minY + maxY) / 2) * scale;
        }

        if (!isFinite(scale) || scale <= 0) { scale = 1; translateX = 0; translateY = 0; }

        const transform = d3.zoomIdentity.translate(translateX, translateY).scale(scale);
        initialTransformRef.current = transform;
        svg.transition().duration(750).call(zoom.transform, transform);
        setZoomValue(Math.round(scale * 10));

    
        if (focusPanelName) {
          const safeFocusPanelName = escapeSelector(focusPanelName);
          const focusPanel = containerRef.current.querySelector(`#${safeFocusPanelName}`);
          if (focusPanel) {
            focusPanel.classList.add('lg-panel--active');
            showPanelAlert(focusPanelName, treeData);
          }
        }
      }
    }, 100);
  };

  const handleReset = () => {
    const container = containerRef.current;
    if (container) {
      container.querySelectorAll('.lg-panel').forEach(panel => {
        panel.classList.remove('highlights-downstream', 'disable-lineagenode', 'lg-panel--active', 'lg-panel--upstream', 'lg-panel--downstream');
      });
      container.querySelectorAll('path.lineage').forEach(path => {
        path.setAttribute('stroke', '#CED4DA');
        path.setAttribute('marker-end', 'url(#arrow)');
      });
    }

    if (svgRef.current && zoomBehaviorRef.current && initialTransformRef.current) {
      d3.select(svgRef.current).transition().duration(750).call(zoomBehaviorRef.current.transform, initialTransformRef.current);
      setZoomValue(Math.round(initialTransformRef.current.k * 10));
    }
  };

  // Zoom in/out handlers
  const handleZoomIn = () => {
    if (svgRef.current && zoomBehaviorRef.current) {
      const svg = d3.select(svgRef.current);
      const transform = d3.zoomTransform(svgRef.current);
      const newScale = Math.min(transform.k * 1.2, 3);
      const newTransform = d3.zoomIdentity.translate(transform.x, transform.y).scale(newScale);
      svg.transition().duration(300).call(zoomBehaviorRef.current.transform, newTransform);
      setZoomValue(Math.round(newScale * 10));
    }
  };

  const handleZoomOut = () => {
    if (svgRef.current && zoomBehaviorRef.current) {
      const svg = d3.select(svgRef.current);
      const transform = d3.zoomTransform(svgRef.current);
      const newScale = Math.max(transform.k / 1.2, 0.1);
      const newTransform = d3.zoomIdentity.translate(transform.x, transform.y).scale(newScale);
      svg.transition().duration(300).call(zoomBehaviorRef.current.transform, newTransform);
      setZoomValue(Math.round(newScale * 10));
    }
  };

  useEffect(() => {
    drawGraph();
    const handleResize = () => {
      drawGraph();
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, lineageGraphExpanded]);

  if (!data.tasks || Object.keys(data.tasks).length === 0) {
    return (
         <div className="placeholder-msg">
            <div className="placeholder-msg__icon">
                <Image src="icon_placeholder_no_pipeline_data" />
            </div>
            <p>No Data Found</p>
          </div>
    );
  }

  return (
    <>

       <div className="linear-vertical-widget-wrap">
                  <div className="linear-vertical-widget">
                    <div className="linear-vertical-widget__item">
                      <RcTooltip 
                        placement="top" 
                        overlay={<span>Reset</span>}
                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                      >
                        <i className="linear-vertical-widget__icon" onClick={handleReset} >
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.668 7.50065V5.00065H14.168V3.33398H16.668C17.1263 3.33398 17.5187 3.49718 17.8451 3.82357C18.1714 4.14996 18.3346 4.54232 18.3346 5.00065V7.50065H16.668ZM1.66797 7.50065V5.00065C1.66797 4.54232 1.83116 4.14996 2.15755 3.82357C2.48394 3.49718 2.8763 3.33398 3.33464 3.33398H5.83464V5.00065H3.33464V7.50065H1.66797ZM14.168 16.6673V15.0007H16.668V12.5007H18.3346V15.0007C18.3346 15.459 18.1714 15.8513 17.8451 16.1777C17.5187 16.5041 17.1263 16.6673 16.668 16.6673H14.168ZM3.33464 16.6673C2.8763 16.6673 2.48394 16.5041 2.15755 16.1777C1.83116 15.8513 1.66797 15.459 1.66797 15.0007V12.5007H3.33464V15.0007H5.83464V16.6673H3.33464ZM5.0013 13.334V6.66732H15.0013V13.334H5.0013ZM6.66797 11.6673H13.3346V8.33398H6.66797V11.6673Z" fill="black" fillOpacity="0.5"/>
                          </svg>
                        </i>
                      </RcTooltip>
                    </div>
                  </div>
                  <div className="linear-vertical-widget">
                    <div className="linear-vertical-widget__item">
                      <RcTooltip 
                        placement="top" 
                        overlay={<span>Zoom In</span>}
                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                      >
                        <i className="linear-vertical-widget__icon" onClick={handleZoomIn} style={{ fontWeight: 'bold', fontSize: '18px' }} >
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 8H14V10H10V14H8V10H4V8H8V4H10V8Z" fill="black" fillOpacity="0.5"/>
                          </svg>
                        </i>
                      </RcTooltip>
                    </div>
                    <div className="linear-vertical-widget__item"><span className='zoom-percentage'>{Math.round(zoomValue * 10)===0 ? 10 : Math.round(zoomValue * 10)}%</span></div>
                    <div className="linear-vertical-widget__item">
                      <RcTooltip 
                        placement="top" 
                        overlay={<span>Zoom Out</span>}
                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                      >
                        <i className="linear-vertical-widget__icon" onClick={handleZoomOut} style={{ fontWeight: 'bold', fontSize: '18px'}} >
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 10H4V8H14V10Z" fill="black" fillOpacity="0.5"/>
                          </svg>
                        </i>
                      </RcTooltip>
                    </div>
                  </div>
                </div>

      <div className="portlet-title d-none">
        <div className="actions" style={{ position: 'relative' }}>
          <div className="zoom-controls" style={{ position: 'absolute', top: 0, right: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px', zIndex: 10 }}>
            <button type="button" className="btn btn-light-secondary" title="Zoom In" onClick={handleZoomIn} style={{ fontWeight: 'bold', fontSize: '18px', width: '40px' }}>+</button>
            <button type="button" className="btn btn-light-secondary" title="Zoom Out" onClick={handleZoomOut} style={{ fontWeight: 'bold', fontSize: '18px', width: '40px' }}>-</button>
            <span style={{ minWidth: 50, textAlign: 'center', fontWeight: 'bold' }}>{Math.round(zoomValue * 10)}%</span>
            <button type="button" className="btn btn-light-secondary" title="Center" onClick={handleReset} style={{ fontWeight: 'bold', fontSize: '16px', width: '60px' }}>Center</button>
          </div>
        </div>
      </div>
      <div className="portlet-body p-0">
        <div ref={containerRef} id={chart_id} className="lineage-graph-container">
          <svg ref={svgRef}></svg>
        </div>
      </div>
    </>
  );
};

export default LineageGraph;